import { cx } from '@growup/ui';
import { useState } from 'react';

import { canManageContent, canManagePartners, type StaffSession } from '../session';

import { CarouselView } from './CarouselView';
import { CategoriesView } from './CategoriesView';
import { MemorialView } from './MemorialView';
import { PagesView } from './PagesView';
import { PartnersView } from './PartnersView';
import { PostsView } from './PostsView';
import { PrizesSection } from './PrizesSection';
import { TextsView } from './TextsView';

type Tab =
  | 'noticias'
  | 'carrossel'
  | 'textos'
  | 'paginas'
  | 'categorias'
  | 'premios'
  | 'memorial'
  | 'parceiros';

const TABS: { id: Tab; label: string; partners?: true }[] = [
  { id: 'noticias', label: 'Notícias' },
  { id: 'carrossel', label: 'Carrossel' },
  { id: 'textos', label: 'Textos' },
  { id: 'paginas', label: 'Páginas' },
  { id: 'categorias', label: 'Categorias' },
  { id: 'premios', label: 'Prémios' },
  { id: 'memorial', label: 'Memorial' },
  // Permissao propria (`partners.manage`), por defeito do Gestor de Conteudo.
  { id: 'parceiros', label: 'Parceiros', partners: true },
];

/**
 * Seccao Conteudos (RF-F1; Gestor de Conteudo e Administrador geral,
 * `content.manage`): o que aparece no site sem mexer no codigo. Ver
 * docs/conteudos.
 */
export function ContentSection({ session }: { session: StaffSession }) {
  const tabs = TABS.filter((t) =>
    t.partners ? canManagePartners(session) : canManageContent(session),
  );
  const [tab, setTab] = useState<Tab>(tabs[0]?.id ?? 'noticias');
  return (
    <>
      <nav className="flex flex-wrap gap-1" aria-label="Conteúdos">
        {tabs.map((t) => (
          <button
            key={t.id}
            type="button"
            aria-current={tab === t.id ? 'page' : undefined}
            onClick={() => setTab(t.id)}
            className={cx(
              'border-b-2 px-3 py-2 font-sub text-label font-bold uppercase',
              tab === t.id
                ? 'border-gu-accent text-gu-ink'
                : 'border-transparent text-gu-ink-muted hover:text-gu-ink',
            )}
          >
            {t.label}
          </button>
        ))}
      </nav>
      {tab === 'noticias' ? <PostsView /> : null}
      {tab === 'carrossel' ? <CarouselView /> : null}
      {tab === 'textos' ? <TextsView /> : null}
      {tab === 'paginas' ? <PagesView /> : null}
      {tab === 'categorias' ? <CategoriesView /> : null}
      {tab === 'premios' ? <PrizesSection /> : null}
      {tab === 'memorial' ? <MemorialView /> : null}
      {tab === 'parceiros' ? <PartnersView /> : null}
    </>
  );
}
